'<template>
    <div>
        <!--Start Middle content-->

        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> 401K Plan <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-3 col-lg-2 pull-right">
                                <v-select v-model="locationType"
                                          name="locationType"
                                          id="locationType"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationTypeArr"
                                          placeholder="Select Location Type">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section plan-401K-main col-12">
            <div class="container">
                <div class="row">
                    <app-slider :sliderType='sliderType' :key='sliderType.location_type'></app-slider>

                    <template v-for="(allData, index) in all401kData">
                        <div class="plan-top-section col-12">
                            <div class="row">
                                <div class="retirement-main-section_left col-12">
                                    <div class="row">
                                        <div class="middle-content employee-middle-content">
                                            <div class="top-title-section">
                                                <h2> Retirement </h2>
                                                <p> Transamerica enrollment website </p>
                                            </div>
                                            <div class="middle-title-section">
                                                <a :href="allData.website_link" target="_blank"> {{websiteLinkName}} </a>
                                                <p> <i class="hi-icon hr-call"> </i> {{allData.contact_number}} </p>
                                            </div>
                                            <div class="bottom-title-section employee-title-section">
                                                <p class="plan-para"> {{allData.description}} </p>
                                                <template v-for="(text, index) in doc401kListNew">
                                                    <div class="bottom-title-section-link col-12" v-if="text.doc_for == 'englishKit'">
                                                        <div class="row">
                                                            <!-- <a :href="text.doc_path" target="_blank" class="hvr-sweep-to-right-red"> Transamerica Enrollment Kit (English) </a> -->
                                                            <a href="#" :id="'id' + index" @click="getSignedUrlPath(text.doc_path)" class="hvr-sweep-to-right-red"> Transamerica Enrollment Kit (English) </a>
                                                        </div>
                                                    </div>
                                                    <div class="bottom-title-section-link col-12" v-if="text.doc_for == 'spanishKit'">
                                                        <div class="row">
                                                            <!-- <a :href="text.doc_path" target="_blank" class="hvr-sweep-to-right-red"> Transamerica Enrollment Kit (Spanish) </a> -->
                                                            <a href="#" :id="'id' + index" @click="getSignedUrlPath(text.doc_path)" class="hvr-sweep-to-right-red"> Transamerica Enrollment Kit (Spanish) </a>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-for="(buttonData, index) in buttonArray">
                                                    <div v-if="buttonData.button_401k_document != ''" class="bottom-title-section-link col-12">
                                                        <div class="row">
                                                            <!-- <a :href="buttonData.button_401k_document" target="_blank" class="hvr-sweep-to-right-red"> {{buttonData.button_title}} </a> -->
                                                            <a href="#" :id="'id' + index" @click="getSignedUrlPath(buttonData.button_401k_document)" class="hvr-sweep-to-right-red"> {{buttonData.button_title}} </a>
                                                        </div>
                                                    </div>
                                                    <div v-if="buttonData.button_url != ''" class="bottom-title-section-link col-12">
                                                        <div class="row">
                                                            <a :href="buttonData.button_url" target="_blank" class="hvr-sweep-to-right-red"> {{buttonData.button_title}} </a>
                                                        </div>
                                                    </div>
                                                </template>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="loan-payoff-section col-12">
                        <div class="row">
                            <template v-for="(allData, index) in all401kData">
                                <div class="loan-payoff-section-left col-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="row">
                                        <h5> {{allData.instruction_title}}:hello </h5>
                                        <ul>
                                            <template v-for="(instruction, index) in instructions">
                                                <li> {{instruction.step}} </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </template>
                            <template v-for="(allData, index) in all401kData">
                                <div class="loan-payoff-section-right col-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="row">
                                        <p class="width-full float-l"> <i class="fa fa-globe color-red heading-text-16 line-height-20 float-l"> </i> <a target="_blank" :href="allData.website_link" class="color-666666 heading-text-16 line-height-20 float-l font-text-semi-bold-mont ml-15"> {{websiteLinkName}} </a> </p>
                                        <p class="mt-20 color-666666 heading-text-16 line-height-20 float-l font-text-semi-bold-mont width-full float-l"> <i class="hi-icon hr-call color-red heading-text-16 line-height-20 float-l mr-15"> </i> {{allData.contact_number}} </p>
                                        <template v-for="(text, index) in doc401kListNew">
                                            <div class="blue-large-button mt-20" v-if="text.doc_for == 'loanPayoffInstruction'">
                                                <!-- <a :href="text.doc_path" target="_blank" class="hvr-sweep-to-right-blue"> Loan Payoff Instructions </a> -->
                                                <a href="#" :id="'id' + index" @click="getSignedUrlPath(text.doc_path)" class="hvr-sweep-to-right-red"> Loan Payoff Instructions </a>
                                            </div>
                                            <template v-if="text.doc_path != ''">
                                                <div class="blue-large-button mt-20" v-if="text.doc_for == 'communications'">
                                                    <!-- <a :href="text.doc_path" target="_blank" class="hvr-sweep-to-right-blue"> Communications </a> -->
                                                    <a href="#" :id="'id' + index" @click="getSignedUrlPath(text.doc_path)" class="hvr-sweep-to-right-red"> Communications </a>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="bottom-plan-section col-12">
                        <div class="row">
                            <p class="bottom-plan-para"> <!-- Your 401k advisors from SageView are available to serve you! -->
                                Questions, concerns, 401k education & support. </p>
                            <div class="bottom-box-section col-12 pr-0 pl-0">
                                <div class="">
                                    <template v-for="(allData, index) in all401kData">
                                        <!-- <div class="internal-box-section col-12 col-sm-4 col-md-4 col-lg-4">
                                            <div class="row">
                                                <h6> {{allData.first_advisor_name}} </h6>
                                                <p>{{allData.first_designation}} <br/> {{getFirstWord(allData.first_advisor_name)}} tambien habla español. </p>
                                                <div class="fone-para">
                                                    <template v-if="allData.first_secondary_phone != ''" v-for="(allData, index) in all401kData">
                                                        <i class="hi-icon hr-call"> </i> <span> {{allData.first_primary_phone}} &nbsp; | &nbsp; {{allData.first_secondary_phone}} </span>
                                                    </template>
                                                    <template v-if="allData.first_secondary_phone == ''" v-for="(allData, index) in all401kData">
                                                        <i class="hi-icon hr-call"> </i> <span> {{allData.first_primary_phone}} </span>
                                                    </template>
                                                </div>
                                                <div class="fone-para email-para">
                                                    <i class="hi-icon hr-email"> </i> <span> <a :href="'mailto:' + allData.first_email">{{allData.first_email}} </a> </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="internal-box-section col-12 col-sm-4 col-md-5 col-lg-4">
                                            <div class="row">
                                                <h6> {{allData.second_advisor_name}} </h6>
                                                <p> {{allData.second_designation}} <br/> {{getFirstWord(allData.second_advisor_name)}} tambien habla español. </p>
                                                <div class="fone-para">
                                                    <template v-if="allData.second_phone_secondary != ''" v-for="(allData, index) in all401kData">
                                                        <i class="hi-icon hr-call"> </i> <span> {{allData.second_phone_primary}} &nbsp; | &nbsp; {{allData.second_phone_secondary}} </span>
                                                    </template>
                                                    <template v-if="allData.second_phone_secondary == ''" v-for="(allData, index) in all401kData">
                                                        <i class="hi-icon hr-call"> </i> <span> {{allData.second_phone_primary}} </span>
                                                    </template>
                                                </div>
                                                <div class="fone-para email-para">
                                                    <i class="hi-icon hr-email"> </i> <span> <a :href="'mailto:' + allData.second_email">{{allData.second_email}}</a> </span>
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="internal-box-link col-12 col-sm-6 col-md-3 col-lg-4"> -->
                                        <div class="internal-box-link col-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="middle-link">
                                                <div class="row">
                                                    <template v-for="(text, index) in doc401kListNew">
                                                        <div class="internal-box-button pb-20" v-if="text.doc_for == 'registrarionInstruction'">
                                                            <!-- <a class="hvr-sweep-to-right-white" :href="text.doc_path" target="_blank"> ONLINE REGISTRATION INSTRUCTIONS > </a> -->
                                                            <a class="hvr-sweep-to-right-white" href="#" :id="'id' + index" @click="getSignedUrlPath(text.doc_path)"> ONLINE REGISTRATION INSTRUCTIONS > </a>
                                                        </div>
                                                    </template>
                                                    <div class="internal-box-button">
                                                        <router-link class="hvr-sweep-to-right-white" v-bind:to="{name: 'Videos401k'}"> 401K Videos > </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="plan-video-main-section col-12 float-l"> <!--video slider-->
                    <!--<div class="row">
                        <div style="display:none;margin:0 auto;" class="html5gallery" data-skin="gallery" data-responsive="true" data-resizemode="fit" data-width="1045" data-height="500">
                    <!-- Add videos to Gallery -->
                    <!-- Add Youtube video to Gallery -->
                    <!-- <a href="http://www.youtube.com/embed/YE7VzlLtp-4"><img src="http://img.youtube.com/vi/YE7VzlLtp-4/2.jpg"></a> -->
                    <!--<a href="https://player.vimeo.com/video/238434274"><img src="images/video-thubnail-img.jpg" alt="Vimeo Video"></a>
                    <!-- Add Vimeo video to Gallery -->
                    <!--<a href="https://player.vimeo.com/video/238434274"><img src="images/video-thubnail-img.jpg" alt="Vimeo Video"></a>
                </div>
            </div>
        </div> <!--video slider-->
                </div>
            </div>
        </div>
        <!--End Middle content-->

    </div>
</template>
<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import SliderComponent from "@/components/SliderComponent";
    var self;
    export default {
        name: 'Plan_401k',
        components: {
            'v-select': vSelect,
            'app-slider': SliderComponent,
        },
        mixins: [SessioMixin],
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                sliderType: {
                    type: '401k',
                    location_type: 'other',
                },
                roleId: 0,
                error: '',
                sliderData: [],
                all401kData: [],
                websiteLinkName: '',
                instructions: [],
                buttonArray: [],
                doc401kListNew: [],
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.loadAll401kData();
            self.load401kDocs();
            self.getBuildVersion();
        },
        watch: {
            locationType: function (locationType) {
                self.sliderType.location_type = locationType.value;
                self.loadAll401kData();
                self.load401kDocs();
            },
        },
        methods: {
            load401kDocs() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    id: 'active',
                    location_type: self.locationType.value,
                };
                HTTP.post("list401kdocs", data, config)
                        .then(function (response) {
                            self.doc401kListNew = response.data.content;
                            // self.englishKitDoc = response.data.content[0].english_kit_doc;
                            // self.spanishKitDoc = response.data.content[0].spanish_kit_doc;
                            // self.loanPayoffInstruction = response.data.content[0].loan_payoff_instruction;
                            // self.registrationInstruction = response.data.content[0].registration_instruction;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            loadAll401kData() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var generalId = 1;
                if (self.locationType.value != 'other') {
                    generalId = 2;
                }
                var data = {
                    id: generalId,
                    location_type: self.locationType.value,
                };

                HTTP.post("getall401kdataforfrontend", data, config)
                        .then(function (response) {
                            self.all401kData = response.data.content;
                            self.websiteLinkName = self.all401kData[0].website_link.replace(/^(?:https?:\/\/)?/i, "").split('/')[0];
                            self.instructions = self.all401kData[0].instruction;
                            self.buttonArray = response.data.button_array;

                            // for (var i = 0; i <= self.buttonArray.length; i++) {
                            //     if (self.buttonArray[i].button_url != '') {
                            //         self.buttonArray[i].buttn_url = buttonUrlName(self.buttonArray[i].button_url);
                            //     }
                            // }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            // buttonUrlName : function (urlNames) {
            //     var urlName = urlNames;
            //     urlName.replace(/^(?:https?:\/\/)?/i, "").split('/')[0];
            //     return urlName;
            // },
            getFirstWord: function (str) {
                str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return str.split(' ')[0];
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Plan401k.vue